module.exports = __webpack_public_path__ + "img/educational-video.0c644723.png";